function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Mini-Card/mapassetdisplay2",
  transform: "translate(-14.000000, -41.000000)",
  fill: "#DA1E28",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Stop_2636497",
  transform: "translate(14.000000, 41.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.4290526,0 L4.57094737,0 L0,4.57094737 L0,11.4290526 L4.57094737,16 L11.4290526,16 L16,11.4290526 L16,4.57094737 L11.4290526,0 Z M10.1625263,12 L7.88547368,9.71957895 L5.60842105,12 L3.88547368,10.2770526 L6.16252632,8 L3.90063158,5.728 L5.62357895,4 L7.88547368,6.26863158 L10.1473684,4 L11.8736842,5.728 L9.60673684,8 L11.8854737,10.2770526 L10.1625263,12 Z",
  id: "Shape"
}))));

var SvgCritical = function SvgCritical(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCritical, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/critical.b17123ec.svg";
export { ForwardRef as ReactComponent };